import { roomString } from "@util/event";

export type ResponseStatus =
  | "Accepted"
  | "Declined"
  | "NeedsAction"
  | "NotApplicable"
  | "Tentative";

export interface IAttendee {
  responseStatus: ResponseStatus;
  urnValue: string;
}

export interface IEvent<A extends IAttendee> {
  attendees: A[];
}

export function getAttendeesBucketedByResponse<A extends IAttendee>(
  event: IEvent<A>,
): Record<ResponseStatus, A[]> {
  const bucketed: Record<ResponseStatus, A[]> = {
    Accepted: [],
    Declined: [],
    NeedsAction: [],
    NotApplicable: [],
    Tentative: [],
  };

  event.attendees
    .filter((attendee) => attendee.urnValue.indexOf(roomString) === -1)
    .forEach((attendee) => bucketed[attendee.responseStatus].push(attendee));

  return bucketed;
}
